import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import store from '../store'
import Home from '../views/home/home.vue'
import { getToken, getUserInfo } from '../http/api'

const routes = [
  {
    path: '/',
    component: Home,
    redirect: '/chatLLM',
  },
  {
    path: '/home',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/home.vue'),
    meta: {
      title: 'iol-lab',
    },
  },
  {
    path: '/homeH5',
    name: 'homeH5',
    component: () =>
      import(/* webpackChunkName: "homeH5" */ '../views/homeH5/index.vue'),
    meta: {
      title: 'iol-lab',
    },
  },
  {
    path: '/novelSplit',
    name: 'novelSplit',
    component: () =>
      import(
        /* webpackChunkName: "novelSplit" */ '../views/novelSplit/novelSplit.vue'
      ),
    meta: {
      title: '网文稿件拆分',
    },
  },
  {
    path: '/termExtraction',
    name: 'termExtraction',
    component: () =>
      import(
        /* webpackChunkName: "termExtraction" */ '../views/termExtraction/termExtraction.vue'
      ),
    meta: {
      title: '译前术语提取',
    },
  },
  {
    path: '/termResult',
    name: 'termResult',
    component: () =>
      import(
        /* webpackChunkName: "termResult" */ '../views/termResult/termResult.vue'
      ),
    meta: {
      title: '译前术语提取结果',
    },
  },
  {
    path: '/toolRequirements',
    name: 'toolRequirements',
    component: () =>
      import(
        /* webpackChunkName: "toolRequirements" */ '../views/toolRequirements/toolRequirements.vue'
      ),
    meta: {
      title: '工具需求',
    },
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () =>
      import(
        /* webpackChunkName: "feedback" */ '../views/feedback/feedback.vue'
      ),
    meta: {
      title: '意见反馈',
    },
  },
  {
    path: '/experience',
    name: 'experience',
    component: () =>
      import(
        /* webpackChunkName: "experience" */ '../views/experience/experience.vue'
      ),
    meta: {
      title: '网文翻译体验',
    },
  },
  {
    path: '/corpusAlignment',
    name: 'corpusAlignment',
    component: () =>
      import(
        /* webpackChunkName: "corpusAlignment" */ '../views/corpusAlignment/index.vue'
      ),
    meta: {
      title: '语料对齐体验',
    },
  },
  {
    path: '/countCalculator',
    name: 'countCalculator',
    component: () =>
      import(
        /* webpackChunkName: "countCalculator" */ '../views/countCalculator/index.vue'
      ),
    meta: {
      title: '字数计算器',
    },
  },
  {
    path: '/memory',
    name: 'memory',
    component: () =>
      import(/* webpackChunkName: "memory" */ '../views/memory/index.vue'),
    meta: {
      title: '语联网实验室',
    },
  },
  {
    path: '/transGPT',
    name: 'transGPT',
    component: () =>
      import(/* webpackChunkName: "transGPT" */ '../views/transGPT/index.vue'),
    meta: {
      title: 'transGPT',
    },
  },
  {
    path: '/bilingualTermMining',
    name: 'bilingualTermMining',
    component: () =>
      import(
        /* webpackChunkName: "bilingualTermMining" */ '../views/bilingualTermMining/index.vue'
      ),
    meta: {
      title: '双语术语挖掘',
    },
  },
  {
    path: '/bilingualTermMiningRes',
    name: 'bilingualTermMiningRes',
    component: () =>
      import(
        /* webpackChunkName: "bilingualTermMiningRes" */ '../views/bilingualTermMiningRes/index.vue'
      ),
    meta: {
      title: '双语术语挖掘结果',
    },
  },
  {
    path: '/rendu',
    name: 'rendu',
    component: () =>
      import(/* webpackChunkName: "rendu" */ '../views/renduLLM/index.vue'),
    meta: {
      title: '任度自研大模型',
    },
  },
  {
    path: '/chatLLM',
    name: 'chatLLM',
    component: () =>
      import(/* webpackChunkName: "chat" */ '../views/chatLLM/index.vue'),
    meta: {
      title: '任度自研大模型',
    },
  },
  {
    path: '/video',
    name: 'video',
    component: () =>
      import(/* webpackChunkName: "video" */ '../views/video/index.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/duixLLM',
    name: 'duixLLM',
    component: () =>
      import(/* webpackChunkName: "duixLLM" */ '../views/duixLLM/index.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/contract',
    name: 'Contract',
    component: () =>
      import(/* webpackChunkName: "contract" */ '../views/contract/index.vue'),
    meta: {
      title: '智能合同脱敏助手',
    },
  },
]
const router = createRouter({
  history: createWebHistory(window.__POWERED_BY_QIANKUN__ ? '/tool' : '/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (to.path == '/detail') {
      window.scrollTo(0, 0)
    }
  },
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const ticket = to.query.ticket
  const token = localStorage.token
  const toEnterpriseId = to.query.enterpriseId
  const fromEnterpriseId = from.query.enterpriseId

  if (ticket) {
    const params = Object.assign({}, to.query)
    delete params.ticket
    getToken({
      ticket,
    }).then((res) => {
      localStorage.token = res.token
      store.commit('comm/changeKey', { token: res.token })
      getUserInfo({ token: res.token }).then((res) => {
        if (!res.id) {
          localStorage.token = ''
          localStorage.userInfo = ''
          store.commit('comm/changeKey', { userInfo: '' })
          store.commit('comm/changeKey', { token: '' })
        } else {
          localStorage.userInfo = JSON.stringify(res)
          store.commit('comm/changeKey', { userInfo: res })
        }

        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          if (to.path === '/rendu') {
            next({
              path: to.path,
              query: {
                ...params,
              },
            })
          } else {
            next('/homeH5')
          }
        } else {
          next({
            path: to.path,
            query: {
              ...params,
            },
          })
        }
      })
    })
    return
  }
  if (to.path.includes('rendu') && !token) {
    window.location.pathname = `/go/iollab_pc_login/${location.pathname}`
    return
  }
  if (toEnterpriseId) {
    next()
    return
  }
  if (!toEnterpriseId && fromEnterpriseId) {
    next({
      path: to.path,
      query: {
        ...to.query,
        enterpriseId: fromEnterpriseId,
      },
    })
    return
  }
  next()
})

export default router
